define(["require", "exports", "preact/hooks", "./authenticationErrors"], function (require, exports, hooks_1, authenticationErrors_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.useAppAuthenticationState = void 0;
    /**
     * Derives the top-level application authentication state used by AppContainer.
     *
     * Recoverable cross-tab authentication changes should prompt re-authentication,
     * but should not render the fatal error page.
     */
    const useAppAuthenticationState = (accessToken, loginError, accessTokenExpired) => {
        const [authenticationError, setAuthenticationError] = (0, hooks_1.useState)(false);
        (0, hooks_1.useEffect)(() => {
            if (accessToken) {
                setAuthenticationError(false);
            }
        }, [accessToken]);
        const sessionExpired = accessTokenExpired || authenticationError;
        const appError = Boolean(loginError) && !(0, authenticationErrors_1.isAuthenticationChangedInAnotherTabError)(loginError);
        return {
            appError,
            sessionExpired,
            setAuthenticationError,
        };
    };
    exports.useAppAuthenticationState = useAppAuthenticationState;
});
